import PropTypes from "prop-types";
import Notification from "components/Notification";

export const myAccountNotificationCodes = new Set([
    "user.currentUserSuccessfulyUpdated",
    "user.missingNewPassword",
    "user.invalidOldPassword",
]);

/**
 * Notification Manager - MyAccount Notifications
 * @return {Node} Returns Notification component
 */
const MyAccountNotifications = ({ identifier, code }) => {
    switch (code) {
        case "user.currentUserSuccessfulyUpdated":
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Profile details successfully updated."
                    type="success"
                    expire="3500"
                />
            );
        case "user.missingNewPassword":
            return (
                <Notification
                    identifier={identifier}
                    title="Error"
                    text="Please enter new password."
                    type="error"
                />
            );
        case "user.invalidOldPassword":
            return (
                <Notification
                    identifier={identifier}
                    title="Error"
                    text="Invalid old password."
                    type="error"
                />
            );
        default:
            return null;
    }
};

MyAccountNotifications.defaultProps = {
    identifier: null,
    code: null,
};

MyAccountNotifications.propTypes = {
    identifier: PropTypes.string,
    code: PropTypes.string,
};

export default MyAccountNotifications;
